import "./App.css";
import React, { useState, useEffect } from "react";
import { Route, Routes, useNavigate, useLocation } from "react-router-dom";
import Homepage from "./views/homepage";
import Contact from "./views/contact";
import Login from "./views/login";
import Search from "./views/search";
import { LinkedInPopUp } from "react-linkedin-login-oauth2";
import Navbar from "./components/Navbar/Navbar";
import { logout, getToken } from "./authetication/loginState";
import Resumaker from "./views/Resumaker/Resumaker";
import ResetPasswordForm from "./components/ResetPasswordForm/ResetPasswordForm";
import MockInterviewerInput from "./views/MockInterviewerInput";
import MockInterviewerZoom from "./views/MockInterviewerZoom";
import MockInterviewerFeedback from "./views/MockInterviewerFeedback";
import CandidateInterviewScreen from "./views/CandidateInterviewScreen";
import OnboardingScreen from "./views/Onboarding";
import CandidateApplicationScreen from "./views/CandidateApplicationScreen";
import FlightAttendantHomeScreen from "./views/FlightAttendantHomeScreen/index.js";
import NursingHomeScreen from "./views/NursingHomeScreen/index.js";
import VerifyDone from "./views/VerifyDone/index.js";
import Profile from "./views/Profile";
import Hotjar from "@hotjar/browser";

import ReactGA from "react-ga4";
import DatabaseVettingScreen from "./components/DatabaseVettingForm/index.js";
import InterviewCoderComparison from "./views/InterviewCoderComparison/index.js";
import StarterPack from "./views/StarterPack/index.js";
import ComparisonLockedInAI from "./views/lockedInAIComparison/index.js";
import ComparisonExponent from "./views/exponentComparison/index.js";
import SitemapComponent from "./components/Sitemap/index.js";

const TRACKING_ID = process.env.REACT_APP_GA_TRACKER; // OUR_TRACKING_ID
const REACT_APP_HOTJAR_SITE_ID = Number(process.env.REACT_APP_HOTJAR_SITE_ID);
const REACT_APP_HOTJAR_VERSION = Number(process.env.REACT_APP_HOTJAR_VERSION);

ReactGA.initialize(TRACKING_ID);
ReactGA.send({
  hitType: "pageview",
  page: window.location.pathname,
  title: "Intern Guys GA",
});

function App() {
  let navigate = useNavigate();
  let location = useLocation();
  const [loggedIn, setLoggedIn] = useState(getToken() ? true : false);
  const logoutUser = () => {
    logout();
    setLoggedIn(false);
    navigate("/");
  };

  useEffect(() => {}, [loggedIn]);

  useEffect(() => {
    if (process.env.NODE_ENV === "production") {
      Hotjar.init(REACT_APP_HOTJAR_SITE_ID, REACT_APP_HOTJAR_VERSION);
    }
  }, []);

  return (
    <div
      className={
        location.pathname === "/" || location.pathname.includes('nursing') || location.pathname.includes('flight-attendant') ? "newNavbarApp" : "App"
      }
    >
      {location.pathname !== "/login" &&
        location.pathname !== "/onboarding" && 
        location.pathname !== "/resetpassword" && (
          <Navbar loginState={{ loggedIn, logoutUser, navigate }} />
        )}
      <Routes>
        <Route
          path="/login"
          element={<Login loginState={{ loggedIn, setLoggedIn, navigate }} />}
        />
        <Route
          path="/resetpassword"
          element={<ResetPasswordForm loginState={{ navigate }} />}
        />
        <Route
          path="/"
          element={<Homepage loginState={{ loggedIn, navigate }} />}
        />
        <Route
          path="/referral/:referrerId/:name"
          element={<Homepage loginState={{ loggedIn, navigate }} />}
        />
        <Route
          path="/nursing"
          element={<NursingHomeScreen loginState={{ loggedIn, navigate }} />}
        />
        <Route
          path="/flight-attendant"
          element={<FlightAttendantHomeScreen loginState={{ loggedIn, navigate }} />}
        />
        <Route path="/contact" element={<Contact />} />
        <Route path="/linkedin-login" element={<LinkedInPopUp />} />
        <Route
          path="/resumaker"
          element={<Resumaker loginState={{ loggedIn, navigate }} />}
        />
        <Route path="/search" element={<Search />} />
        <Route
          path="/mockInterviewerInput"
          element={<MockInterviewerInput />}
        />
        <Route path="/mockInterviewerZoom" element={<MockInterviewerZoom />} />
        <Route path="/interview-coder-alternative" element={<InterviewCoderComparison />} />
        <Route path="/starter-pack" element={<StarterPack />} />
        <Route
          path="/verify-done"
          element={<VerifyDone />}
        />
        <Route path="/lockedin-ai-alternative" element={<ComparisonLockedInAI />} />
        <Route path="/exponent-alternative" element={<ComparisonExponent />} />
        <Route path="/profile-update/:candidateToInterviewId" element={<DatabaseVettingScreen />} />
        <Route
          path="/mockInterviewerFeedback"
          element={<MockInterviewerFeedback />}
        />
        <Route
          path="/interview/:candidateToInterviewId"
          element={<CandidateInterviewScreen />}
        />
        <Route path="/onboarding" element={<OnboardingScreen />} />
        <Route
          path="/job/:companyInterviewId/company/:companyId"
          element={<CandidateApplicationScreen />}
        />
        <Route path="/profile" element={<Profile />} />
      </Routes>
    </div>
  );
}

export default App;